import Link from "next/link";
import { useRouter } from "next/router";
import Image from "next/image";
import ThumborJS from "thumborjs";

const imageUrl = process.env.NEXT_PUBLIC_IMAGE_URL;
const thumborKey = process.env.NEXT_PUBLIC_THUMBOR_KEY;
const thumborUrl = process.env.NEXT_PUBLIC_THUMBOR_URL;

const CardBrand = ({ brand }) => {
  const router = useRouter();
  let queryParam = router?.query?.aid ? `aid=${router?.query?.aid}` : ``;
  queryParam = router?.query?.pid
    ? `${queryParam}&pid=${router?.query?.pid}`
    : queryParam;

  queryParam = router?.query?.pf
    ? `${queryParam}pf=${router?.query?.pf}`
    : queryParam;

  if (router?.query?.utm_source) {
    queryParam = queryParam
      ? `${queryParam}&utm_source=${router?.query?.utm_source}`
      : `?utm_source=${router?.query?.utm_source}`;
  }

  const myLoader = ({ src }) => {
    if (src.split("?")?.length > 1) {
      return `${src}`;
    } else {
      const tugen = new ThumborJS(thumborUrl, thumborKey);
      const url = tugen
        .imgpath(src)
        .resize(50, 0)
        .filter("format(webp)")
        .genurl();
      return url;
    }
  };

  const image_path = brand?.logo?.replace(/\/uploads/g, "");
  const imageProduct = brand?.logo
    ? `${imageUrl}${image_path}`
    : brand?.logo
    ? brand?.logo
    : `${process.env.NEXT_PUBLIC_FRONTEND_URL}/static/images/thumbnail.jpeg`;

  return (
    <Link
      prefetch={false}
      href={`/${encodeURIComponent(brand?.name)}${
        queryParam ? `?${queryParam}` : ``
      }`}
      title={brand?.name}
    >
      <div className="brand-container">
        <div className="w-[50px] h-[50px] brand-wrap">
          <Image
            loader={myLoader}
            src={imageProduct}
            alt={brand?.name}
            width={50}
            height={50}
            quality={20}
            loading="lazy"
            placeholder="blur"
            blurDataURL={`data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII=`}
          />
        </div>
        <p className="p-1 text-xs text-center text-black">{brand?.name}</p>
      </div>
    </Link>
  );
};

const App = ({ brands }) => (
  <div className="px-4">
    <div className="flex justify-between ">
      <p className="h4 mt-0">{`Shop by Brand`}</p>
    </div>
    <div className="grid grid-cols-4 xs:grid-cols-4 sm:grid-cols-4 md:grid-cols-8 gap-4">
      {brands?.map((v) => {
        return (
          <div className="mt-4" key={`brand-${v?.name}`}>
            <CardBrand brand={v} />
          </div>
        );
      })}
    </div>
  </div>
);

export default App;
